module.exports = __webpack_public_path__ + "Fieldata_logo_hvit.png";